/**
 * Chrome (title + close) for notary splash modals. Body text stays NEXT_PUBLIC_SPLASH_MESSAGE / runtime config.
 * Set NEXT_PUBLIC_NOTARY_SPLASH_LOCALE=en at build (e.g. env-full) when the notary UI targets English for these labels.
 */

export type NotarySplashChromeLocale = "fr" | "en";

export function resolveNotarySplashChromeLocale(): NotarySplashChromeLocale {
	const raw = process.env["NEXT_PUBLIC_NOTARY_SPLASH_LOCALE"]?.trim().toLowerCase() ?? "";
	if (raw === "en" || raw === "en-us" || raw === "en-gb") {
		return "en";
	}
	return "fr";
}

export function getNotarySplashChromeLabels(locale: NotarySplashChromeLocale): { title: string; closeButton: string } {
	if (locale === "en") {
		return { title: "What's new", closeButton: "Close" };
	}
	return { title: "Nouveautés", closeButton: "Fermer" };
}
